<template>
  <PageTemplate>

    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-actions text-right">
        <CreateButton
            :label="$t('travel_expenses.create')"
            @click="handleFormModal">
        </CreateButton>
      </div>

      <h6 class="element-header">
        {{ $t('travel_expenses.title') }}
      </h6>

      <Search
          :filters="filters"
          :loading="isSearching"
          :monthsInYearDropdown="enums.monthsInYear"
          :yearsDropdown="yearsDropdown"
          @search="getTravelExpensesList"/>

      <div class="element-box mt-0">
        <Menu/>

        <PerPage :values="[10, 25, 50, 100]" @update:perPage="getTravelExpensesList"/>

        <div class="table-responsive mt-3">
          <table class="table table-striped">
            <thead>
            <tr>
              <th class="text-right">
                {{ $t('general.year') }}
              </th>
              <th class="text-left" style="padding-left: 60px;">
                {{ $t('general.month') }}
              </th>
              <th class="text-right">
                {{ $t('general.kilometer') }}
              </th>
              <th class="text-right">
                {{ $t('general.price') }}
              </th>
              <th class="text-right">
                {{ $t('general.total') }}
              </th>
              <th class="text-center">
                {{ $t('general.status') }}
              </th>
              <th class="text-center">
              </th>
              <th class="text-center">
              </th>
              <th style=" text-align: right; padding-right: 30px; min-width: 150px;">
                {{ $t('general.actions') }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="expense in travelExpenses.data" :key="expense.id">
              <td class="text-right" style="width: 100px;">
                <strong class="js-lists-values-employee-name">
                  {{ expense.year }}
                </strong>
              </td>
              <td class="text-left" style="padding-left: 60px;">
                <strong class="js-lists-values-employee-name">
                  {{ $t(`calendar.months_number_key.${expense.month}`) }}
                </strong>
              </td>
              <td class="text-right" style="width: 150px;">
                <strong class="js-lists-values-employee-name">
                  {{ expense.distance }}
                </strong>
              </td>
              <td class="text-right" style="width: 150px;">
                <strong class="js-lists-values-employee-name">
                  {{ expense.price }} €
                </strong>
              </td>
              <td class="text-right" style="width: 150px;">
                <strong class="js-lists-values-employee-name">
                  {{ expense.total }} €
                </strong>
              </td>
              <td class="text-center">
                <span v-if="expense.status === 'draft'" class="status-pill yellow p-2 ml-1"
                      data-toggle="tooltip"></span>
                <span v-if="expense.status === 'modification'" class="status-pill red p-2 ml-1"
                      data-toggle="tooltip"></span>
                <span v-if="expense.status === 'pending'" class="status-pill yellow p-2 ml-1"
                      data-toggle="tooltip"></span>
                <span v-if="expense.status === 'approved_by_coordinator'" class="status-pill p-2 ml-1"
                      style="background-color: mediumseagreen" data-toggle="tooltip"></span>
                <span v-if="expense.status === 'approved'" class="status-pill green p-2 ml-1"
                      data-toggle="tooltip"></span>
                <span class="ml-2">{{ expense.statusTranslated }}</span>
              </td>
              <td class="text-right">
                <!-- Waiting approval -->
                  <template v-if="expense.userNotification">
                    <i style="font-size: 26px; color: #43ad4e;" class="os-icon os-icon-alert-circle"></i>
                    <span style="
                              position:absolute;
                              font-size: 8px;
                              padding: 3px 8px;
                              background-color: red;
                              color: white;
                              border-radius: 11px;">!</span>
                  </template>
              </td>
              <td class="text-right">
                <!-- Unseen messages  -->
                <template v-if="expense.userUnseenCount">
                  <i style="font-size: 26px; color: #43ad4e;" class="os-icon os-icon-mail-07"></i>
                  <span style="
                            position:absolute;
                            font-size: 8px;
                            padding: 3px 8px;
                            background-color: red;
                            color: white;
                            border-radius: 11px;">!</span>
                </template>
              </td>
              <td class="text-right">
                <button class="btn btn-primary"
                        @click="router.push({name: 'travelExpensesDetails', params: {id: expense?.id} })">
                  <i class="os-icon os-icon-edit"></i>
                </button>
                <button v-if="expense.status === 'draft'" class="btn btn-danger ml-2"
                        @click="deleteModal(expense?.id)">
                  <i class="os-icon os-icon-trash"></i>
                </button>
                <div v-else style="width: 50px; float:right; color: white">
                  Empty content
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <Pagination
            v-if="travelExpenses?.pagination?.total_pages > 1"
            :totalPages="travelExpenses?.pagination?.total_pages"
            :currentPage="travelExpenses?.pagination?.current_page"
            @pagechanged="getTravelExpensesList"/>
      </div>
    </div>

    <ModalDelete
        v-model="showModal"
        :header="t('general.delete_item_header')"
        :onDelete="deleteTravelExpenses">
    </ModalDelete>

    <Modal
        v-model="showFormModal"
        title="Fahrtkosten"
        :hide-cancel="true"
        :button-label="$t('general.button.save')"
        sizeModal="modal-xl"
        :hide-footer="true"
        classFooter="justify-content-center">
      <Form
          infoLabel="Bitte beachte, dass du Fahrtkosten für einen neuen Monat erstellst!"
          @createTravelExpenses="getTravelExpensesList"
          v-model:submitForm="submitForm"/>
    </Modal>

  </PageTemplate>
</template>


<script setup>
import travelExpensesService from '@/api/TravelExpenses';
import CreateButton from '@/components/CreateButton.vue';
import Loader from '@/components/Loader.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import router from '@/router';
import {getYears} from '@/shared/dropdowns';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import Search from '@/views/App/TravelExpenses/User/List/Search.vue';
import {onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import Modal from "@/components/modal/Modal.vue";
import Form from "@/views/App/TravelExpenses/User/Form.vue";
import Menu from "@/views/App/TravelExpenses/User/List/Menu.vue";

const {enums} = piniaEnumsStore();
const {t} = useI18n();
const travelExpenseId = ref(null);
const travelExpenses = ref([]);
const showModal = ref(false);
const isSearching = ref(false);
const isLoaded = ref(false);
const yearsDropdown = ref([]);
const showFormModal = ref(false);
const submitForm = ref(false);

watch(submitForm, () => {
  showFormModal.value = false;
});

const filters = ref({
  year: '',
  month: '',
});

async function getTravelExpensesList(page = 1, perPage, passedFilters) {
  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = travelExpenses.value?.pagination?.items_per_page;

  try {
    const {data} = await travelExpensesService.getPendingAndActiveList({
      page: page,
      limit: perPage ?? perPageRes,
      ...(passedFilters ? passedFilters : filters.value),
    });

    travelExpenses.value = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

async function deleteTravelExpenses() {
  try {
    await travelExpensesService.deleteTravelExpenses(travelExpenseId.value);

    showModal.value = false;
    travelExpenseId.value = null;

    await getTravelExpensesList();
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}


function handleFormModal() {
  CloseToast();
  showFormModal.value = true;
  showModal.value = false;
  travelExpenseId.value = '';
}

function deleteModal(id) {
  CloseToast();
  travelExpenseId.value = id;
  showModal.value = true;
}

onMounted(async () => {
  await getYears(yearsDropdown);
  await getTravelExpensesList();

  isLoaded.value = true;
});


</script>

<style scoped>

</style>